import { Box, styled } from '@mui/material'

export const StyledPageDivider = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'progress' && prop !== 'flat',
})(({ theme, progress = '25%', flat = false }) => ({
  position: 'relative',
  margin: theme.spacing(6, 0),
  '.arrow': {
    position: 'absolute',
    top: '50%',
    left: progress,
    transform: 'translate(-50%, -50%)',
    color: theme.palette.primary.main,
  },
  '.lines': {
    width: progress,
    position: 'relative',
    textAlign: 'center',
    '&::before, &::after': {
      content: '" "',
      display: 'block',
      margin: 0,
      width: '100%',
      height: theme.spacing(0.6),
      borderRadius: flat ? 0 : 100,
      backgroundColor: theme.palette.tertiary.main,
    },
    '&::before': {
      marginBottom: theme.spacing(0.25),
    },
    '&::after': {
      backgroundColor: theme.palette.secondary.main,
    },
    '&.ghost': {
      opacity: 0.5,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      margin: 0,
    },
  },
  '&.right': {
    '.arrow': {
      left: 'unset',
      right: progress,
    },
    '.lines': {
      width: `calc(100% - ${progress})`,
    },
  },
}))